import i18next from 'i18next';
import React from 'react';
import en from './i18n/en';
import ptBr from './i18n/pt-br';

i18next.addResourceBundle('pt-br', 'receita/cadastro/cliente', ptBr);
i18next.addResourceBundle('en', 'receita/cadastro/cliente', en);

const ClienteConfig = {
  settings: {
    layout: {
      config: {},
    },
  },
  routes: [
    {
      path: '/vendas-servicos/cliente',
      component: React.lazy(() => import('./Cliente')),
    },
  ],
};

export default ClienteConfig;
